<script setup>
import TheHeader from "./components/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import MobileMenu from "./components/MobileMenu.vue";
import WhatsAppWidget from "./components/chat/WhatsAppWidget.vue";
import { ref } from "vue";
import { useSeoMeta } from './composables/useSeoMeta';
import StructuredData from './components/StructuredData.vue';
import SkipLinks from './components/SkipLinks.vue';
import LoadingSpinner from './components/LoadingSpinner.vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

// Initialize SEO meta tags
useSeoMeta();

const isMenuOpen = ref(false);
const isLoading = ref(false);

// Route loading states
router.beforeEach(() => {
  isLoading.value = true;
});

router.afterEach(() => {
  // Small delay to prevent flash
  setTimeout(() => {
    isLoading.value = false;
  }, 100);
});

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  if (isMenuOpen.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};
</script>

<template>
  <div class="flex flex-col min-h-screen bg-white">
    <SkipLinks />
    <StructuredData />

    <!-- Route loading overlay -->
    <LoadingSpinner
      v-if="isLoading"
      full-screen
      overlay
      size="large"
      color="mint"
      message="Loading..."
    />

    <TheHeader @toggle-menu="toggleMenu" :is-menu-open="isMenuOpen" />
    <div class="flex-grow" id="main-content" role="main">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <TheFooter />
    <MobileMenu v-if="isMenuOpen" @close="toggleMenu" />
    <WhatsAppWidget />
  </div>
</template>
